import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueLuckyCanvas from "@lucky-canvas/vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import axios from "axios";
import VueAxios from "vue-axios";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueConfetti from "vue-confetti";
import "animate.css";

Vue.use(VueConfetti);
Vue.use(VueSweetalert2);
Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
Vue.use(VueLuckyCanvas);
Vue.use(VuePersianDatetimePicker, {
  name: "my-date-picker",
  props: {
    format: "YYYY/MM/DD",
    displayFormat: "jYYYY/jMM/jDD",
    editable: false,
    inputClass: "form-control wheel_birth_field",
    placeholder: "Please select a date",
    altFormat: "YYYY/MM/DD",
    color: "#f77f00",
    autoSubmit: false,
    min: "1940/03/21",
    max: "2012/03/19",
  },
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
